module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-2.ecf9416e.png";